export default {
  'Common.AdAccount': 'AdWords Account',
  'Common.Agree': 'Yes, I agree',
  'Common.Attention': 'ATTENTION',
  'Common.BackToAllVisits': 'Back to Visits',
  'Common.BackToDetails': 'Back to Details',
  'Common.BackToOverview': 'Back to Overview',
  'Common.BackToVisitDetails': 'Back to Visit Details',
  'Common.Cancel': 'Cancel',
  'Common.ConfirmationPasswordError': 'Two passwords that you enter are inconsistent!',
  'Common.ConfirmationPasswordSecureRule': 'Your password is not secure. Please ensure its minimum length is 8.',
  'Common.DateRange.LastMonth': 'Last Month',
  'Common.DateRange.LastSixMonths': 'Last 6 Months',
  'Common.DateRange.LastTwelveMonths': 'Last 12 Months',
  'Common.DateRange.LastWeek': 'Last Week',
  'Common.DateRange.SpecificDate': 'Specific Date',
  'Common.DateRange.Today': 'Today',
  'Common.DiscardChanges': 'Are you sure you want to discard your changes? Data can be lost',
  'Common.Download': 'Download',
  'Common.Downloads': 'Downloads',
  'Common.Email.Invalid': 'Please provide the correct email',
  'Common.EndDate': 'End date',
  'Common.EntryPage': 'Entry page',
  'Common.ExitPage': 'Exit page',
  'Common.Exporting': 'Exporting',
  'Common.Field.Required': 'The field is required',
  'Common.Field.RequiredAndNumber': 'The field is required and must be a number',
  'Common.InvalidToken': 'Your token has expired.',
  'Common.InvalidTokenOrEmail': 'There is no such email on the database or your token has expired.',
  'Common.Languages.Name.de': 'German',
  'Common.Languages.Name.en': 'English',
  'Common.LastExport': 'Last export initiated',
  'Common.LoadMore': 'Load More',
  'Common.More': 'More',
  'Common.NA': 'N/A',
  'Common.NewExport': 'Start new export',
  'Common.NewImport': 'Import {fileName}',
  'Common.SelectFile': 'Select File (.xls)',
  'Common.NextPage': 'Next page',
  'Common.No': 'No',
  'Common.NoData': 'No data',
  'Common.NotFound': 'Not Found',
  'Common.Or': 'or',
  'Common.Outlinks': 'Links outside',
  'Common.Paginator.Total': 'Showing {from} to {to} of {total} entries',
  'Common.PreviousPage': 'Previous page',
  'Common.Remove': 'Remove',
  'Common.Roles.Admin': 'Admin',
  'Common.Roles.Editor': 'Editor',
  'Common.Roles.Viewer': 'Viewer',
  'Common.Save': 'Save',
  'Common.Search': 'Search',
  'Common.SearchHere': 'Search here',
  'Common.Select.NotFoundContent': 'No items found',
  'Common.StartDate': 'Start date',
  'Common.Success': 'Success',
  'Common.Time': 'Time',
  'Common.TotalTimeOnPage': 'Total time on this page',
  'Common.TotalTimeOnVisit': 'Total time on visit',
  'Common.Unknown': 'Unknown',
  'Common.Yes': 'Yes',
  'Component.AccountSettings.Add.Success.Text': 'The Account was successfully created',
  'Component.AccountSettings.DuplicatedPairUserRole': 'Combination of users and roles should be unique',
  'Component.AccountSettings.Edit.DeleteDomain': 'Remove domain',
  'Component.AccountSettings.Edit.Success.Text': 'The Account was successfully changed',
  'Component.AccountSettings.Edit.Title': 'Edit account',
  'Component.AccountSettings.List.Action.Create': 'New Account',
  'Component.AccountSettings.List.Description1': 'Maintain your accounts and their contents here',
  'Component.AccountSettings.List.Description2': 'If necessary, you can also add more.',
  'Component.AccountSettings.List.Title': 'Account settings',
  'Component.AccountSettings.List.SearchPlaceholder': 'Search by account name',
  'Component.AccountSettings.MatomoConfigurations': 'Matomo configurations',
  'Component.AccountSettings.New.AvailableRoles.Title': 'Available roles:',
  'Component.AccountSettings.New.Description.Title': 'Add a new Account',
  'Component.AccountSettings.New.Domain.Save': 'Save domain',
  'Component.AccountSettings.New.DomainSection.MatomoDomainName': 'Domain Name',
  'Component.AccountSettings.New.DomainSection.MatomoProjectName': 'Project Name',
  'Component.AccountSettings.New.DomainSection.MatomoIdName': 'Website Id',
  'Component.AccountSettings.New.DomainSection.MatomoTimezone': 'Domain timezone',
  'Component.AccountSettings.New.DomainSection.Name': 'Domain name',
  'Component.AccountSettings.New.DomainSection.TestMatomoId': 'Test the Matomo website ID',
  'Component.AccountSettings.New.DomainSection.Title': 'Domain',
  'Component.AccountSettings.New.Project.Name': 'Project Name',
  'Component.AccountSettings.New.Info1': 'Add a new Account by clicking',
  'Component.AccountSettings.New.Info2': 'You can also give users rights to their domains.',
  'Component.AccountSettings.New.InfoList1': 'add the domain name',
  'Component.AccountSettings.New.InfoList2': 'Select your modules',
  'Component.AccountSettings.New.InfoList3': 'Add users and their rights.',
  'Component.AccountSettings.New.ModulesSection.Title': 'Module',
  'Component.AccountSettings.New.DomainSection.AllowedDomains': 'Allowed domains',
  'Component.AccountSettings.New.DomainSection.DisallowedDomains': 'Disallowed domains',
  'Component.AccountSettings.New.DomainSection.AddDomain': 'Add Domain',
  'Component.AccountSettings.New.DomainSection.AddDomain.ValidationMessage': 'Field is required, please enter valid domain name or remove the field',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Admin': '- Admin      = Has full access to accounts made available to him',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Editor': '- Editor     = May authorize free accounts',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Editor.Span': 'Change elements *',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.SuperAdmin': '- Superadmin = account holder, has full access to all accounts',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Viewer': '- Viewer      = May authorize free accounts',
  'Component.AccountSettings.New.PopoverText.AvailableRoles.Viewer.Span': 'See items * but do not change',
  'Component.AccountSettings.New.Title': 'Add a new Account',
  'Component.AccountSettings.New.Title1': 'Add a new Account',
  'Component.AccountSettings.New.UserSection.AddUser': 'Add User',
  'Component.AccountSettings.New.UserSection.Role': 'Role',
  'Component.AccountSettings.New.UserSection.Title': 'User',
  'Component.AccountSettings.New.UserSection.User': 'User',
  'Component.AccountSettings.New.AccountSection.Account': 'Account',
  'Component.AccountSettings.New.AnalyticsSection.Matomo': 'Matomo configuration',
  'Component.AccountSettings.New.AnalyticsSection.GoogleAnalytics': 'Google Analytics configuration',
  'Component.AccountSettings.New.InstallCodes': 'Install Codes',
  'Component.AccountSettings.New.Integrations': 'Integrations',
  'Component.AccountSettings.New.Integrations.VisitWebhookUrl': 'Visit Webhook URL',
  'Component.AccountSettings.New.Integrations.VisitWebhookMinimalScore': 'Visit Minimal Score',
  'Component.AccountSettings.New.Integrations.VisitWebhookToken': 'Visit Webhook Token',
  'Component.AccountSettings.New.Integrations.VisitWebhookTokenSet': 'Visit Webhook Token is set',
  'Component.AccountSettings.New.Integrations.VisitWebhookTokenNotSet': 'Visit Webhook Token is not set',
  'Component.AccountSettings.New.Integrations.VisitWebhookToken.ConfirmTokenUpdate': 'Do you want to update the token? Previous token will be invalid.',
  'Component.AccountSettings.New.GoogleOfflineConversion': 'Google Offline Conversion',
  'Component.AccountSettings.New.GoogleOfflineConversion.Enabled': 'Enabled',
  'Component.AccountSettings.New.GoogleOfflineConversion.Type': 'Type',
  'Component.AccountSettings.New.GoogleOfflineConversion.MinimalScore': 'Minimal Score',
  'Component.AccountSettings.New.GoogleOfflineConversion.LeadScoringProfile': 'Lead Scoring Profiles',
  'Component.AccountSettings.New.GoogleOfflineConversion.SheetId': 'Sheet Id',
  'Component.AccountSettings.New.GoogleOfflineConversion.SheetName': 'Sheet Name',
  'Component.AccountSettings.New.GoogleOfflineConversion.ConversionName': 'Conversion Name',
  'Component.AccountSettings.New.OfflineConversion.Type.All': 'All visible',
  'Component.AccountSettings.New.OfflineConversion.Type.ByScoringNumber': 'By Scoring Number',
  'Component.AccountSettings.New.OfflineConversion.Type.ByScoringProfile': 'By Scoring Profile',
  'Component.AccountSettings.New.OfflineConversion.Type.ByHubspotStatus': 'By Hubspot Status',
  'Component.AccountSettings.New.MicrosoftOfflineConversion': 'Microsoft Offline Conversion',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.Enabled': 'Enabled',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.Type': 'Type',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.MinimalScore': 'Minimal Score',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.LeadScoringProfile': 'Lead Scoring Profiles',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.ClientId': 'Client Id',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.CustomerId': 'Customer Id',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.AccountId': 'Account Id',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.ConversionName': 'Conversion Name',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.ConfirmSecretUpdate': 'Confirm Secret Value Update',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.DeveloperToken': 'Developer Token',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.DeveloperTokenSet': 'Developer Token Set',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.DeveloperTokenNotSet': 'Developer Token Not Set',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.RefreshToken': 'Refresh Token',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.RefreshTokenSet': 'Refresh Token Set',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.RefreshTokenNotSet': 'Set Refresh Token',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.RefreshToken.Modal.Title': 'Authorize Microsoft Offline Conversion',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.RefreshToken.Modal.Step1': 'Step 1: Copy and paste the link below to authorize the application with Microsoft:',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.RefreshToken.Modal.Step2': 'Step 2: After authorizing, paste the redirect URL you were taken to:',
  'Component.AccountSettings.New.MicrosoftOfflineConversion.RefreshToken.Modal.Placeholder': 'Paste redirect URL here',
  'Component.AccountSettings.Overview.Info1': 'Maintain your accounts and their contents here',
  'Component.AccountSettings.Overview.Info2': 'If necessary, you can also add more.',
  'Component.AccountSettings.Overview.NewDomainBtn': 'New Account',
  'Component.AccountSettings.Overview.Title': 'Account Overview',
  'Component.AccountSettings.RegenerateToken': 'Re-generate Access Token',
  'Component.AccountSettings.RegenerateTokenModal.Text': 'Are you sure? When new token is generated you have to change it for all integration connected to this account.',
  'Component.AccountSettings.Remove.Modal.Description': 'Do you really want to remove this project "{projectName}"?',
  'Component.AccountSettings.Remove.Success.Text': 'The domain was successfully removed.',
  'Component.AccountSettings.TokenModal.Text': 'Here is you access token for website integration',
  'Component.AccountSwitcher.Modal.Description': 'You are trying to switch to account "{accountName}". All unsaved data will be lost. Proceed?',
  'Component.AccountSwitcher.Switched': 'Account switched',
  'Component.AdWords.List.Title': 'AdWords',
  'Component.Branches.Change.Description1': 'Edit Branch by naming and collecting the appropriate groups.',
  'Component.Branches.Change.Description2': 'Among the main groups are even more differentiated subgroups. You can also select these individually using the checkbox.',
  'Component.Branches.Change.Form.AddTranslation': 'Add translation',
  'Component.Branches.Change.Form.Cancel': 'Cancel',
  'Component.Branches.Change.Form.Delete': 'Delete branch',
  'Component.Branches.Change.Form.DownloadBranches': 'Download Branches as XLS',
  'Component.Branches.Change.Form.IndustryName': 'Branch name',
  'Component.Branches.Change.Form.Submit': 'Save',
  'Component.Branches.Change.Form.TgTitle': 'Branch Selection',
  'Component.Branches.Change.Modal.Info': 'The Branch was created successfully.',
  'Component.Branches.Change.Modal.Ok': 'To the Branches overview',
  'Component.Branches.Change.Title': 'Edit Branch',
  'Component.Branches.Edit.Success.Text': 'The branch was successfully changed',
  'Component.Branches.KompassCodes.ExportFinished': 'Export of standard branches as xls completed',
  'Component.Branches.KompassCodes.MainBranch': 'Main branches',
  'Component.Branches.KompassCodes.SelectedBranch': 'Your branch selection',
  'Component.Branches.KompassCodes.SubBranch': 'Sub-branches',
  'Component.Branches.KompassCodes.Title': 'Select Branches',
  'Component.Branches.KompassCodes.ValidationMessage': 'At least one branch must be selected',
  'Component.Branches.List.Create': 'Add a new Branch',
  'Component.Branches.List.Description1': 'Here you will find all your applied industries.',
  'Component.Branches.List.Description2': 'Please note that any change in an already used industry has an impact on your data!',
  'Component.Branches.List.SearchByName': 'Type a name to search for a Branch',
  'Component.Branches.List.Title': 'Branches Management',
  'Component.Branches.Modal.Description': 'Do you really want to remove this Branch ?',
  'Component.Branches.New.Description1': 'Create a new Branch by naming and collecting the appropriate groups.',
  'Component.Branches.New.Description2': 'Among the main Branches are even more differentiated subbranches. You can also select these individually using the checkbox.',
  'Component.Branches.New.Form.AddTranslation': 'Add translation',
  'Component.Branches.New.Form.Cancel': 'Cancel',
  'Component.Branches.New.Form.DownloadBranches': 'Download Branches as XLS',
  'Component.Branches.New.Form.IndustryName': 'Branch name',
  'Component.Branches.New.Form.Submit': 'Save',
  'Component.Branches.New.Form.TgTitle': 'Branch',
  'Component.Branches.New.Modal.Info': 'The Branch was created successfully.',
  'Component.Branches.New.Modal.Ok': 'To the Branches overview',
  'Component.Branches.New.Success.Text': 'New branch was successfully created',
  'Component.Branches.New.Title': 'Create Branch',
  'Component.Branches.Remove.Success.Text': 'The Branch was successfully removed',
  'Component.Branches.Replace': 'Replace Branch',
  'Component.Branches.Replace.Confirm.Text': 'Have you removed the Branch from all Target Groups?',
  'Component.Branches.Replace.Option': 'Option',
  'Component.Branches.Replace.Option1.Text': 'Do you want to replace this branch everywhere with a particular Branch?',
  'Component.Branches.Replace.Option2.Text': 'Or do you want to edit the corresponding Branch individually?',
  'Component.Branches.Replace.Success.Text': 'The Branch was replaced in all related Target Groups and successfully removed',
  'Component.Branches.Replace.Warning.Text': 'This Branch is already used in {targetGroupsCount} active target groups and therefore can not be deleted.',
  'Component.Branches.ReplaceModal.Ok': 'Yes, delete the Branch',
  'Component.Branches.Start.Create': 'Add a new Branch',
  'Component.Branches.Start.Description1': 'You have decided to use your own Branches.',
  'Component.Branches.Start.Description2': 'To create Target Group for Dynamic Content, you must first create your industries.',
  'Component.Branches.Start.Title': 'Manage Branches',
  'Component.Categories.Edit.Cancel': 'Cancel',
  'Component.Categories.Edit.CatName': 'Category Name',
  'Component.Categories.Edit.Delete': 'Remove category',
  'Component.Categories.Edit.Error': 'This name is already in use, please choose another one',
  'Component.Categories.Edit.Save': 'Save Changes',
  'Component.Categories.Edit.Success.Text': 'The category was successfully updated.',
  'Component.Categories.Edit.Title': 'Category: ',
  'Component.Categories.List.Action.Create': 'New Category',
  'Component.Categories.List.Info': 'Manage your Categories and create new ones as needed',
  'Component.Categories.List.SearchByName': 'Type a name to search for a Category',
  'Component.Categories.List.Title': 'Categories Management',
  'Component.Categories.Modal.Description': 'Do you really want to remove category "{categoryName}"?',
  'Component.Categories.New.Cancel': 'Cancel',
  'Component.Categories.New.CatName': 'Category Name',
  'Component.Categories.New.Description': 'Add a new category',
  'Component.Categories.New.Error': 'This name is already in use, please choose another one',
  'Component.Categories.New.Label': 'Fields with * are mandatory',
  'Component.Categories.New.Save': 'Create category',
  'Component.Categories.New.Success.Text': 'The category was successfully created.',
  'Component.Categories.New.Title': 'New category',
  'Component.Categories.Remove.Success.Text': 'The category was successfully removed.',
  'Component.Common.ScoringCircle.PrivateProfile': 'Private',
  'Component.Common.ScoringCircle.PublicProfile': 'Public',
  'Component.Common.ScoringCircle.ScoreLabel': 'Score:',
  'Component.Company.CreateButton': 'New Company',
  'Component.Company.Item.AddTitle': 'Add Company',
  'Component.Company.Item.Attribute': 'Add attribute',
  'Component.Company.Item.DeleteCompany': 'Remove company',
  'Component.Company.Item.EditTitle': 'Edit Company',
  'Component.Company.Item.LeadLabel': 'Lead Labels',
  'Component.Company.Item.MandatoryLabel': 'Fields with * are mandatory',
  'Component.Company.Item.Name': 'Company name',
  'Component.Company.Item.CustomerNumber': 'Customer Number',
  'Component.Company.Item.ResetChanges': 'Cancel',
  'Component.Company.Item.Save': 'Save changes',
  'Component.Company.Item.Success.Text': 'The company was successfully updated.',
  'Component.Company.List.SearchByName': 'Type a name to search for a Company',
  'Component.Company.List.Title': 'List of Сompanies',
  'Component.Company.Modal.Delete.Description': 'Do you really want to remove this Company?',
  'Component.Company.Remove.Success.Text': 'The company was successfully removed',
  'Component.Company.Update.Success.Text': 'The company was successfully updated',
  'Component.Campaigns.List.Title': 'List of Campaigns',
  'Component.Campaigns.Item.Edit': 'Edit Campaign',
  'Component.Campaigns.Create': 'New Campaign',
  'Component.Campaign.Item.Label': 'Label',
  'Component.Campaign.Item.Key': 'Key',
  'Component.Campaign.Item.Name': 'Name',
  'Component.Campaigns.List.SearchPlaceholder': 'Type a label to search for a Campaign',
  'Component.Campaigns.New.Success.Text': 'The campaign was successfully added',
  'Component.Campaigns.Update.Success.Text': 'The campaign was successfully updated',
  'Component.Campaigns.Remove.Success.Text': 'The campaign was successfully removed',
  'Component.Campaigns.Modal.Description': 'Do you really want to remove Campaign "{campaignName}"?',
  'Component.CountryRegions.Create': 'New Land Group',
  'Component.CountryRegions.Description': 'Manage your Land Groups and create new ones as needed',
  'Component.CountryRegions.Edit.Success.Text': 'The Land Group was successfully updated.',
  'Component.CountryRegions.Form.Countries': 'Countries',
  'Component.CountryRegions.Form.Name': 'Land Group name',
  'Component.CountryRegions.Form.Title.Edit': 'Edit Land Group',
  'Component.CountryRegions.Form.Title.New': 'New Land Group',
  'Component.CountryRegions.List.SearchByNamePlaceholder': 'Type a name to search for a Land Group',
  'Component.CountryRegions.Modal.Description': 'Do you really want to remove Land Group "{countryRegionName}"?',
  'Component.CountryRegions.New.Success.Text': 'The Land Group was successfully created.',
  'Component.CountryRegions.Remove.Success.Text': 'The Land Group was successfully removed.',
  'Component.CountryRegions.Title': 'Land Groups',
  'Component.CountryRegions.Validation.Countries': 'Please input Countries',
  'Component.CountryRegions.Validation.Name': 'Please input Land Group name',
  'Component.Dashboard.ChangePassword': 'Change password',
  'Component.Dashboard.WelcomeMessage': 'Welcome to Customer Portal',
  'Component.DynamicContent.Branches.Button': 'Create branches',
  'Component.DynamicContent.Branches.Desc1': 'You have decided to use your own branches groups.',
  'Component.DynamicContent.Branches.Desc2': 'To create target groups for Dynamic Content, you must first create your branches.',
  'Component.DynamicContent.CreateButton': 'New Target Group',
  'Component.DynamicContent.First.Button': 'Create target group',
  'Component.DynamicContent.Overview.Description': 'Here is an overview of all your saved target groups that you can link to dynamic content in your TYPO3.',
  'Component.DynamicContent.Overview.ModalRemove.Description': 'Do you really want to remove this target group?',
  'Component.DynamicContent.Overview.ModalRemove.Title': 'Attention!',
  'Component.DynamicContent.Title': 'Dynamic content',
  'Component.Industries.List.Title': 'Manage industries',
  'Component.LeadDetails.Address': 'Address',
  'Component.LeadDetails.AllVisits': 'All Visits',
  'Component.LeadDetails.Branch': 'Branches',
  'Component.LeadDetails.BranchOfIndustry': 'Branch of industry',
  'Component.LeadDetails.Campaign': 'Campaign',
  'Component.LeadDetails.ClassificationCodes': 'Classification Codes',
  'Component.LeadDetails.CompanyDetails': 'Company Details',
  'Component.LeadDetails.Date': 'Date',
  'Component.LeadDetails.Details': 'show details',
  'Component.LeadDetails.Domain': 'Domain',
  'Component.LeadDetails.Duration': 'Duration',
  'Component.LeadDetails.EmployeesCount': 'Number of employees',
  'Component.LeadDetails.LeadMarks': 'Lead Labels',
  'Component.LeadDetails.LoadMore': 'Load more',
  'Component.LeadDetails.Pages': 'Pages',
  'Component.LeadDetails.SetMarks': 'Type a name to search for a Lead Label',
  'Component.LeadDetails.ShowAll': 'Show all Scores',
  'Component.LeadDetails.SocialMedia': 'Socialmedia',
  'Component.LeadDetails.Source': 'Source',
  'Component.LeadDetails.TotalVisits': 'Number of visits',
  'Component.LeadDetails.VisitsCount': 'Total Amount of Visits',
  'Component.LeadDetails.Website': 'Website',
  'Component.LeadLabels.Change.Description': 'Edit Lead Label',
  'Component.LeadLabels.Change.Form.Cancel': 'Cancel',
  'Component.LeadLabels.Change.Form.Delete': 'Remove Lead Label',
  'Component.LeadLabels.Change.Form.Submit': 'Save Changes',
  'Component.LeadLabels.Change.Title': 'Edit Lead Label',
  'Component.LeadLabels.Edit.Success.Text': 'The Lead Label was successfully updated.',
  'Component.LeadLabels.Form.AddTranslation': 'Add translations',
  'Component.LeadLabels.Form.Label.Name': 'Lead Label Name',
  'Component.LeadLabels.List.Action.Create': 'New Lead Label',
  'Component.LeadLabels.List.Info': 'Manage your Lead Labels here and create new ones as needed',
  'Component.LeadLabels.List.SearchByNamePlaceholder': 'Type a name to search for a Lead Label',
  'Component.LeadLabels.List.Title': 'Lead Labels Management',
  'Component.LeadLabels.New.Description': 'Create Lead Label',
  'Component.LeadLabels.New.Form.Submit': 'Create Lead Label',
  'Component.LeadLabels.New.Success.Text': 'New Lead Label was successfully created.',
  'Component.LeadLabels.New.Title': 'New Lead Label',
  'Component.LeadLabels.Remove.Modal.Description': 'Do you really want to remove Lead Label "{leadLabel}"?',
  'Component.LeadLabels.Remove.Success.Text': 'The Lead Label was successfully removed.',
  'Component.Leads.CompaniesList.Title': 'Lead Management - Companies',
  'Component.Leads.CompaniesList.Description': 'In the Lead Management, you have an overview of all your companies and can theirs Evaluate behavior on your site.',
  'Component.Leads.VisitsList.Button.Hint.Hide': 'Hide Company',
  'Component.Leads.VisitsList.Button.Hint.MarkAsIsp': 'Mark as ISP',
  'Component.Leads.VisitsList.Button.Hint.MarkAsNotIsp': 'Mark as not ISP',
  'Component.Leads.VisitsList.Button.Hint.OpenWebiste': 'Open Company website',
  'Component.Leads.VisitsList.Button.Hint.QuickView': 'Quick View',
  'Component.Leads.VisitsList.Button.Hint.Unhide': 'Unhide Company',
  'Component.Leads.VisitsList.Button.Hint.ViewDetails': 'Company Details',
  'Component.Leads.VisitsList.Button.Hint.VisitDetails': 'Visit Details',
  'Component.Leads.VisitsList.Description1': 'In the Lead Management, you have an overview of all your visitors and can theirs Evaluate behavior on your site.',
  'Component.Leads.VisitsList.ExportFinished': 'Export of Companies Visits completed. Please proceed to "Lead Management -> Visits" for downloading.',
  'Component.Leads.VisitsList.Title': 'Lead Management - Visits',
  'Component.LeadScoring.Title.Settings': 'Profile Settings',
  'Component.LeadScoring.Title.Hubspot': 'HubSpot',
  'Component.LeadScoring.Title.HubspotDescription': 'Activate it to automatically create HubSpot deals that match the criteria below.',
  'Component.LeadScoring.Edit.Cancel': 'Cancel',
  'Component.LeadScoring.Edit.CatName': 'Profile',
  'Component.LeadScoring.Edit.Delete': 'Remove Scoring Profile',
  'Component.LeadScoring.Edit.Description': 'Customize the Profile',
  'Component.LeadScoring.Edit.Error': 'This Name is already in use, please choose another one',
  'Component.LeadScoring.Edit.Label': 'Fields with * are mandatory',
  'Component.LeadScoring.Edit.Save': 'Save Changes',
  'Component.LeadScoring.Edit.Success.Text': 'The Scoring Profile was successfully updated.',
  'Component.LeadScoring.Edit.Title': 'Lead Scoring: ',
  'Component.LeadScoring.Field.Attribute.ClassificationCodes.Placeholder': 'Type a name to search for a Classification Code',
  'Component.LeadScoring.Form.AddCondition': 'Add Condition',
  'Component.LeadScoring.Form.Assertion': 'Condition',
  'Component.LeadScoring.Form.Attribute': 'Attribute Set {set}',
  'Component.LeadScoring.Form.Condition': 'Relation',
  'Component.LeadScoring.Form.Connector': 'Connector',
  'Component.LeadScoring.Form.DeleteAttribute.Hint': 'Remove Attribute Set',
  'Component.LeadScoring.Form.Enabled': 'Enabled',
  'Component.LeadScoring.Form.LogicalOperator': 'Operator',
  'Component.LeadScoring.Form.ProfileScore': 'Score',
  'Component.LeadScoring.Form.Public': 'Public',
  'Component.LeadScoring.Form.PublicDisabledOnEditHint': 'It is not allowed to change Scoring Profile visibility.',
  'Component.LeadScoring.Form.ShortDescription': 'Description',
  'Component.LeadScoring.Form.TestAttribute.Hint': 'Show visits that are matched within the attribute. The table shows up to 1000 latest visits.',
  'Component.LeadScoring.Form.TestingPeriod': 'Testing Period',
  'Component.LeadScoring.Form.TestPeriod': 'Last {days} days',
  'Component.LeadScoring.Form.TestProfile': 'Test Profile',
  'Component.LeadScoring.Form.TestProfile.Hint': 'Show visits that are matched within the Scoring Profile. The table shows up to 1000 latest visits.',
  'Component.LeadScoring.Form.HubspotActive': 'Active',
  'Component.LeadScoring.Form.HubspotTaskAssignee': 'Assignee',
  'Component.LeadScoring.Form.DealPipeline': 'Deal Pipeline',
  'Component.LeadScoring.Form.DealPipelineStage': 'Deal Stage',
  'Component.LeadScoring.Form.Type': 'Type',
  'Component.LeadScoring.Form.Value': 'Value',
  'Component.LeadScoring.Form.Value.Duration': 'Value (seconds)',
  'Component.LeadScoring.Grid.LastChanged': 'Updated at',
  'Component.LeadScoring.Grid.ProfileName': 'Name',
  'Component.LeadScoring.Grid.User': 'User',
  'Component.LeadScoring.Grid.HubspotAssignee': 'Hubspot Assignee',
  'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.and': 'And',
  'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.Is': 'Is',
  'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.Not': 'Is not',
  'Component.LeadScoring.LeadScoringAttributeCondition.ValueLabel.or': 'Or',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.contains': 'Contains',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.ends_with': 'Ends With',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.eq': 'Equal',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.gte': 'Greater or Equal',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.lte': 'Less or Equal',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.range': 'Range',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.regexp': 'Regexp Pattern',
  'Component.LeadScoring.LeadScoringAttributeOperator.ValueLabel.starts_with': 'Starts With',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.branch': 'Branch',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.classification_code': 'Classification Code',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.company_pattern': 'Company Name',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.company_size': 'Company Headcount',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.country': 'Country',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.country_group': 'Land Region',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.duration': 'Duration',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.email_click': 'Email Click',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.file_download': 'File Download',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.form_submit': 'Form Submit',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.isp': 'ISP',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.hidden': 'Hidden',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.lead_label': 'Lead Label',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.page_group': 'Page Group',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.phone_click': 'Phone Click',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.referrer': 'Referrer Url',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.returned_visitor': 'Number of Visits',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.source': 'Source',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.zip_code': 'Zip Code',
  'Component.LeadScoring.LeadScoringAttributeType.ValueLabel.campaign': 'Campaign',
  'Component.LeadScoring.List.Filter.All': 'All Scoring Profiles',
  'Component.LeadScoring.List.Private': 'Private Scoring Profiles',
  'Component.LeadScoring.List.Profile.Create': 'New Scoring Profile',
  'Component.LeadScoring.List.Profile.Edit': 'Edit Scoring Profile',
  'Component.LeadScoring.List.Profile.Info': 'Manage your Scoring Profiles and create new ones as needed',
  'Component.LeadScoring.List.Public': 'Public Scoring Profiles',
  'Component.LeadScoring.List.SearchByNamePlaceholder': 'Type a name to search for a Scoring Profile',
  'Component.LeadScoring.List.SearchByHubspotAssignee': 'Type a HubSpot assignee name',
  'Component.LeadScoring.Modal.Description': 'Do you really want to remove Scoring Profile "{profileName}"?',
  'Component.LeadScoring.New.Cancel': 'Cancel',
  'Component.LeadScoring.New.CatName': 'Profile Name',
  'Component.LeadScoring.New.Description': 'Add a new Scoring Profile',
  'Component.LeadScoring.New.Error': 'This name is already in use, please choose another one',
  'Component.LeadScoring.New.Save': 'Create Scoring Profile',
  'Component.LeadScoring.New.Success.Text': 'The Scoring Profile was successfully created.',
  'Component.LeadScoring.New.Title': 'Create new Scoring Profile',
  'Component.LeadScoring.Remove.Success.Text': 'The Scoring Profile was successfully removed.',
  'Component.LeadsVisitsFilter.Advanced': 'Advanced',
  'Component.LeadsVisitsFilter.Branch': 'Filter by Branch',
  'Component.LeadsVisitsFilter.Campaign': 'Filter by campaign keyword',
  'Component.LeadsVisitsFilter.CampaignName': 'Filter by campaign name',
  'Component.LeadsVisitsFilter.ClearAllFilters': 'Clear All Filters',
  'Component.LeadsVisitsFilter.CompanyName': 'Filter by Company',
  'Component.LeadsVisitsFilter.CompanyNameSearch': 'Filter by Company name',
  'Component.LeadsVisitsFilter.CustomerNumberSearch': 'Filter by Customer Number',
  'Component.LeadsVisitsFilter.CompanyVisibility.All': 'Show all',
  'Component.LeadsVisitsFilter.CompanyVisibility.Filtered': 'Show filtered',
  'Component.LeadsVisitsFilter.CompanyVisibility.Hidden': 'Show hidden',
  'Component.LeadsVisitsFilter.CompanyVisibility.Visible': 'Show visible',
  'Component.LeadsVisitsFilter.CompanyVisibilityPlaceholder': 'Filter by Company Visibility',
  'Component.LeadsVisitsFilter.HubspotTask': 'Filter by HubSpot status',
  'Component.LeadsVisitsFilter.HubspotTask.ValueAll': 'Show all',
  'Component.LeadsVisitsFilter.HubspotTask.ValueHasTask': 'Processed',
  'Component.LeadsVisitsFilter.HubspotTask.ValueNoTask': 'Unprocessed',
  'Component.LeadsVisitsFilter.HubspotTask.Pending': 'Pending',
  'Component.LeadsVisitsFilter.Country': 'Filter by Country',
  'Component.LeadsVisitsFilter.City': 'Filter by City',
  'Component.LeadsVisitsFilter.FilterAndSort': 'Filter & sort',
  'Component.LeadsVisitsFilter.HideAdvanced': 'Hide advanced',
  'Component.LeadsVisitsFilter.Label': 'Filter by Lead Label',
  'Component.LeadsVisitsFilter.LessFilters': 'Less Filters',
  'Component.LeadsVisitsFilter.Period': 'Period',
  'Component.LeadsVisitsFilter.Score': 'Filter by Score',
  'Component.LeadsVisitsFilter.ScoringAll': 'All',
  'Component.LeadsVisitsFilter.ScoringNoScore': 'No Score',
  'Component.LeadsVisitsFilter.ScoringProfiles': 'Filter by Scoring Profile',
  'Component.LeadsVisitsFilter.ScoringProfilesAll': 'All',
  'Component.LeadsVisitsFilter.ScoringProfilesPrivate': 'Private',
  'Component.LeadsVisitsFilter.ScoringProfilesPublic': 'Public',
  'Component.LeadsVisitsFilter.ScoringProfilesVisibilityPlaceholder': 'Filter by Scoring Profile Visibility',
  'Component.LeadsVisitsFilter.ShowHidden': 'Show Hidden',
  'Component.LeadsVisitsFilter.ShowISP': 'Show ISP',
  'Component.LeadsVisitsFilter.ShowKompassBranches': 'Show Classification Codes',
  'Component.LeadsVisitsFilter.Source': 'Filter by Source',
  'Component.NavMenu.Companies': 'Companies',
  'Component.NavMenu.Companies.Attributes': 'Attributes',
  'Component.NavMenu.Companies.Overview': 'Company Attributes',
  'Component.NavMenu.Campaigns.Overview': 'Campaigns',
  'Component.NavMenu.DynamicContent': 'Dynamic Content',
  'Component.NavMenu.LeadManagement': 'Lead Management',
  'Component.NavMenu.LeadManagement.AllVisitDetailsTitle': 'Visit details',
  'Component.NavMenu.LeadManagement.AllVisitsTitle': 'Lead Management - All visits',
  'Component.NavMenu.LeadManagement.Companies': 'Companies',
  'Component.NavMenu.LeadManagement.PageDetailsTitle': '- Page details',
  'Component.NavMenu.LeadManagement.SessionRecording': 'Session Recording',
  'Component.NavMenu.LeadManagement.Visits': 'Visits',
  'Component.NavMenu.Logout': 'Logout',
  'Component.NavMenu.Settings': 'Settings',
  'Component.NavMenu.Administration': 'Administration',
  'Component.PageGroups.Create': 'New Page Group',
  'Component.PageGroups.Description': 'Manage your Page Groups and create new ones as needed',
  'Component.PageGroups.Form.Add': 'Add URL set',
  'Component.PageGroups.Form.Edit': 'Edit Page Group',
  'Component.PageGroups.Form.Name': 'Page Group name',
  'Component.PageGroups.Form.New': 'New Page Group',
  'Component.PageGroups.Form.Operator': 'Operator',
  'Component.PageGroups.Form.Value': 'Value',
  'Component.PageGroups.List.Label': 'Page Group Management',
  'Component.PageGroups.List.SearchByNamePlaceholder': 'Type a name to search for a Page Groups',
  'Component.PageGroups.Modal.Description': 'Do you really want to remove Page Group "{pageGroupName}"?',
  'Component.PageGroups.Operator.contains': 'Contains',
  'Component.PageGroups.Operator.ends_with': 'Ends With',
  'Component.PageGroups.Operator.eq': 'Equal',
  'Component.PageGroups.Operator.regexp': 'Regexp Pattern',
  'Component.PageGroups.Operator.starts_with': 'Starts With',
  'Component.PageGroups.Title': 'Page Group',
  'Component.PageGroups.URLset': 'URL set',
  'Component.PageGroups.Validation.Name': 'Please input Page Group name',
  'Component.PageGroups.Validation.Operator': 'Please input Operator',
  'Component.PageGroups.Validation.Value': 'Please input Value',
  'Component.Settings.LeadLabels.Label': 'Lead Labels Management',
  'Component.Settings.LeadScoring.List.Label': 'Lead Scoring',
  'Component.Sider.Trigger': 'Collapse sidebar',
  'Component.TargetGroup.Branches.AvailableBranches': 'Available Branches',
  'Component.TargetGroup.Branches.Description': 'Please select the appropriate Branches.',
  'Component.TargetGroup.Branches.NoItems': 'No items',
  'Component.TargetGroup.Branches.Search': 'Search Branches',
  'Component.TargetGroup.Branches.SelectedBranches': 'Selected Branches',
  'Component.TargetGroup.Branches.Title': 'Branches',
  'Component.TargetGroup.Branches.ValidationMessage': 'At least one branch must be selected',
  'Component.TargetGroup.Change.Description': 'Do you want to make a change to this target group?',
  'Component.TargetGroup.Change.Form.AddCampaign': 'Add a campaign',
  'Component.TargetGroup.Change.Form.AddCountry': 'Another country',
  'Component.TargetGroup.Change.Form.Campaign': 'Campaigns',
  'Component.TargetGroup.Change.Form.CampaignAdGroup': 'AD Group',
  'Component.TargetGroup.Change.Form.CampaignInfo': 'To apply your campaigns, you must first link your ',
  'Component.TargetGroup.Change.Form.CampaignMandatoryLabel': 'Fields with * are mandatory.',
  'Component.TargetGroup.Change.Form.Cancel': 'Cancel changes',
  'Component.TargetGroup.Change.Form.Category': 'Category',
  'Component.TargetGroup.Change.Form.CompSize': 'Company Size',
  'Component.TargetGroup.Change.Form.Country': 'Country',
  'Component.TargetGroup.Change.Form.Delete': 'Remove this target group',
  'Component.TargetGroup.Change.Form.DownloadBranches': 'Download standard branches as xls',
  'Component.TargetGroup.Change.Form.Error': 'This field is required',
  'Component.TargetGroup.Change.Form.New.Category': 'New category',
  'Component.TargetGroup.Change.Form.Save': 'Save changes in this target group',
  'Component.TargetGroup.Change.Form.ShortDesc': 'Short description',
  'Component.TargetGroup.Change.Form.TargetGroupActive': 'Activate target group',
  'Component.TargetGroup.Change.Form.TargetGroupName': 'Target group name',
  'Component.TargetGroup.Change.Modal.Info': 'Your changes were saved successfully',
  'Component.TargetGroup.Change.Modal.Ok': 'Go to the Target Groups overview',
  'Component.TargetGroup.Change.Title': 'Edit target group',
  'Component.TargetGroup.ClassificationCodes.Title': 'Classification Codes',
  'Component.TargetGroup.Edit.Success': 'The target group was successfully updated',
  'Component.TargetGroup.From': 'From',
  'Component.TargetGroup.LeadLabel.Title': 'Lead Label',
  'Component.TargetGroup.List.SearchByName': 'Type a name to search for a Target Group',
  'Component.TargetGroup.List.FilterByCategory': 'Filter By Category',
  'Component.TargetGroup.Modal.Remove.Description': 'Do you really want to remove this Target Group?',
  'Component.TargetGroup.Modal.Remove.Title': 'Attention!',
  'Component.TargetGroup.New.Description1': 'Create the target group here, which you can then link to dynamic content in TYPO3.',
  'Component.TargetGroup.New.Description2': 'For a better overview, you can give a short description.',
  'Component.TargetGroup.New.Description3': 'For a faster visual assignment, enter a Category.',
  'Component.TargetGroup.New.Form.AddCampaign': 'Add a Campaign',
  'Component.TargetGroup.New.Form.AddCountry': 'Another country',
  'Component.TargetGroup.New.Form.CampaignAdGroup': 'AD Group',
  'Component.TargetGroup.New.Form.CampaignInfo': 'To apply your campaigns, you must first link your ',
  'Component.TargetGroup.New.Form.CampaignMandatoryLabel': 'Fields with * are mandatory.',
  'Component.TargetGroup.New.Form.CampaignName': 'Campaign Name',
  'Component.TargetGroup.New.Form.CampaignParameter': 'Parameter',
  'Component.TargetGroup.New.Form.CampaignSave': 'Save Target Group',
  'Component.TargetGroup.New.Form.CampaignSaveTitle1': 'Are you agree with your selection?',
  'Component.TargetGroup.New.Form.CampaignSaveTitle2': 'Then do not forget to save these.',
  'Component.TargetGroup.New.Form.CampaignTitle': 'Campaigns',
  'Component.TargetGroup.New.Form.CampaignValue': 'Value',
  'Component.TargetGroup.New.Form.Category': 'Category',
  'Component.TargetGroup.New.Form.CompSize': 'Company Size',
  'Component.TargetGroup.New.Form.Country': 'Country',
  'Component.TargetGroup.New.Form.CountryRegions': 'Land Regions',
  'Component.TargetGroup.New.Form.DownloadBranches': 'Download standard branches as xls',
  'Component.TargetGroup.New.Form.Error': 'This field is required',
  'Component.TargetGroup.New.Form.New.Category': 'New Category',
  'Component.TargetGroup.New.Form.ShortDesc': 'Short description',
  'Component.TargetGroup.New.Form.TargetGroupActive': 'Activate target group',
  'Component.TargetGroup.New.Form.TargetGroupName': 'Target Group name',
  'Component.TargetGroup.New.Success': 'Target group was successfully created.',
  'Component.TargetGroup.New.Title': 'Create new Target Group',
  'Component.TargetGroup.NewCategory.Description': 'Add a new Category',
  'Component.TargetGroup.NewCategory.Form.Cancel': 'Cancel',
  'Component.TargetGroup.NewCategory.Form.Name': 'Category name',
  'Component.TargetGroup.NewCategory.Form.Save': 'Create category',
  'Component.TargetGroup.NewCategory.Modal.Info': 'The category was created successfully and can be applied immediately',
  'Component.TargetGroup.NewCategory.Modal.Ok': 'OK',
  'Component.TargetGroup.NewCategory.Title': 'New Category',
  'Component.TargetGroup.Remove.Success': 'The target group was successfully removed',
  'Component.TargetGroup.To': 'to',
  'Component.User.Administration.Create': 'New User',
  'Component.User.Administration.Description': 'You can create additional users and grant them corresponding rights',
  'Component.User.Administration.Edit.Success.Text': 'The user details were successfully updated.',
  'Component.User.Administration.Modal.Description': 'Do you really want to remove user "{first_name} {last_name}"?',
  'Component.User.Administration.Own.Edit.Description': 'You can view your data here and change it if necessary.',
  'Component.User.Administration.Own.Edit.Title': 'Your profile',
  'Component.User.Administration.Remove.Success.Text': 'The user was successfully removed.',
  'Component.User.Administration.Role': 'You are ',
  'Component.User.Administration.SearchByEmailPlaceholder': 'Type an email to search for a User',
  'Component.User.Administration.Title': 'User Administration',
  'Component.User.Administration.Users.Delete.Modal.Description': 'Do you really want to remove this user?',
  'Component.User.Administration.Users.Delete.Modal.Title': 'ATTENTION',
  'Component.User.Administration.Users.Edit.AccessTitle': 'Access rights',
  'Component.User.Administration.Users.Edit.AddAcount': 'Add account',
  'Component.User.Administration.Users.Edit.Avatar': 'Profile pictures',
  'Component.User.Administration.Users.Edit.Cancel': 'Cancel',
  'Component.User.Administration.Users.Edit.Delete': 'Delete user',
  'Component.User.Administration.Users.Edit.Description': 'You can change here user data and assign appropriate access rights.',
  'Component.User.Administration.New.Form.Title': 'Add a New User',
  'Component.User.Administration.Edit.Form.Title': 'Edit User',
  'Component.User.Administration.Users.Edit.Form.Account': 'Account',
  'Component.User.Administration.Users.Edit.Form.Email': 'E-mail',
  'Component.User.Administration.Users.Edit.Form.Email2': 'Enter your e-mail address again',
  'Component.User.Administration.Users.Edit.Form.Error': 'This field is required',
  'Component.User.Administration.Users.Edit.Form.ErrorValid': 'This field is not valid',
  'Component.User.Administration.Users.Edit.Form.fName': 'First name',
  'Component.User.Administration.Users.Edit.Form.Lang': 'Language',
  'Component.User.Administration.Users.Edit.Form.lName': 'Last name',
  'Component.User.Administration.Users.Edit.Form.Password': 'Password',
  'Component.User.Administration.Users.Edit.Form.Password2': 'Enter your password again',
  'Component.User.Administration.Users.Edit.Form.Role': 'Role',
  'Component.User.Administration.Users.Edit.MandatoryLabel': 'Fields with * are mandatory',
  'Component.User.Administration.Users.Edit.Modal.Info': 'Your changes were saved successfully',
  'Component.User.Administration.Users.Edit.Modal.Ok': 'Back to the user overview',
  'Component.User.Administration.Users.Edit.Save': 'Save changes',
  'Component.User.Administration.Users.Edit.Title': 'Edit user:',
  'Component.User.Administration.Users.Edit.Title.UserName': 'User name',
  'Component.User.Administration.Users.New.AccessTitle': 'Access rights',
  'Component.User.Administration.Users.New.AddAcount': 'Add account',
  'Component.User.Administration.Users.New.Avatar': 'Profile pictures',
  'Component.User.Administration.Users.New.Cancel': 'Cancel',
  'Component.User.Administration.Users.New.Description': 'Create a new User and give him appropriate access rights.',
  'Component.User.Administration.Users.New.Form.Account': 'Account',
  'Component.User.Administration.Users.New.Form.Email': 'E-mail',
  'Component.User.Administration.Users.New.Form.Error': 'This field is required',
  'Component.User.Administration.Users.New.Form.fName': 'First name',
  'Component.User.Administration.Users.New.Form.Lang': 'Language',
  'Component.User.Administration.Users.New.Form.lName': 'Last name',
  'Component.User.Administration.Users.New.Form.Role': 'Role',
  'Component.User.Administration.Users.New.MandatoryLabel': 'Fields with * are mandatory',
  'Component.User.Administration.Users.New.Modal.Ok': 'To the user overview',
  'Component.User.Administration.Users.New.PersonalData': 'Personal Data',
  'Component.User.Administration.Users.New.Save': 'Create new User',
  'Component.User.Administration.Users.New.Success.Text': 'The User was created successfully and is now listed in your user overview.',
  'Component.User.Administration.Users.New.Title': 'Add a new User',
  'Component.User.Administration.Users.New.SuperAdmin': 'Super Admin permission',
  'Component.User.Administration.Users.New.SuperAdmin.Description': 'Super Admin permission, has full access to all accounts',
  'Components.FirstLogin.Header': 'Hello ',
  'Components.FirstLogin.PasswordConfirmError': 'Please confirm your password!',
  'Components.FirstLogin.PasswordConfirmLabel': 'Confirm Password',
  'Components.FirstLogin.PasswordError': 'Please enter your password!',
  'Components.FirstLogin.PasswordLabel': 'New Password',
  'Components.FirstLogin.PasswordMismatchError': 'Two passwords that you enter is inconsistent!',
  'Components.FirstLogin.Text.Password1': 'Minimum 8 characters',
  'Components.FirstLogin.Text.Password2': 'Upper and lowercase letter',
  'Components.FirstLogin.Text.Password3': "at least one special character (!\"§$%&/()=?*+'#,;.:-_–)",
  'Components.FirstLogin.Text.Password4': 'at least one number between 0 and 9',
  'Components.FirstLogin.Text1': 'You want to log in for the first time.',
  'Components.FirstLogin.Text2': 'Please change the password that you received from us by e-mail first.',
  'Components.FirstLogin.Text3': 'Avoid passwords that are easy to guess or already used.',
  'Components.FirstLogin.Text4': 'Pay attention to the following:',
  'Components.FirstLogin.Text5': 'The strength of your password can be seen on the scale.',
  'Components.FirstLogin.Text6': 'As soon as the scale moves into the green area, your password is sufficiently protected.',
  'Components.ForgotPassword.BackToLogin': 'Back to login',
  'Components.ForgotPassword.BadRequest': 'Email doesn\'t exist',
  'Components.ForgotPassword.FirstIndent': 'An e-mail to reset your password has been sent to you.',
  'Components.ForgotPassword.HeaderText': 'Forgot Password',
  'Components.ForgotPassword.NewPasswordRequest': 'Request new password',
  'Components.ForgotPassword.SecondIndent': 'If you have not received such an e-mail from us, please check your spam folder or contact us: {supportEmail}',
  'Components.ForgotPassword.SuccessRequest': 'Email was successfully sent',
  'Components.ForgotPassword.ThankYou': 'Thank you very much!',
  'Components.LoginForm.ForgotPassword': 'Forgot password?',
  'Components.LoginForm.HeaderText': 'Please login with your email address and password.',
  'Components.LoginForm.Password.ErrorText': 'Please input your password',
  'Components.LoginForm.Password.Label': 'Password',
  'Components.LoginForm.Username.ErrorText': 'Please input your username',
  'Components.LoginForm.Username.Label': 'Email',
  'Components.LoginForm.ValidationHint': 'Fields marked with * are mandatory.',
  'Components.LoginForm.2FA.HeaderText': 'Please confirm access to your account by entering the authentication code provided by your authenticator application.',
  'Components.LoginForm.Code.Label': 'Code',
  'Components.LoginForm.RecoveryCode.Label': 'Recovery code',
  'Components.LoginForm.UseRecoveryCode': 'Use recovery code',
  'Components.LoginForm.UseCode': 'Use authentication code',
  'Grid.Column.Company': 'Company Details',
  'Grid.Column.Accounts': 'Accounts',
  'Grid.Column.Actions': 'Actions',
  'Grid.Column.Active': 'Active',
  'Grid.Column.AmountOfPages': 'Amount of pages',
  'Grid.Column.AssignmentToCompanyTracker': 'Classification Codes',
  'Grid.Column.Branches': 'Branches',
  'Grid.Column.Campaign': 'Campaign',
  'Grid.Column.Campaigns': 'Campaigns',
  'Grid.Column.Category': 'Category',
  'Grid.Column.City': 'City',
  'Grid.Column.ClassificationCodes': 'Classification Codes',
  'Grid.Column.CompanyName': 'Company Name',
  'Grid.Column.CompanySize': 'Company Size',
  'Grid.Column.Copy': 'Copy',
  'Grid.Column.Country': 'Country',
  'Grid.Column.CountryRegions': 'Land Regions',
  'Grid.Column.Date': 'Date',
  'Grid.Column.Delete': 'Delete',
  'Grid.Column.Details': 'Details',
  'Grid.Column.Domain': 'Domain',
  'Grid.Column.Account': 'Account',
  'Grid.Column.Duration': 'Duration',
  'Grid.Column.DurationOfVisit': 'Duration of visit',
  'Grid.Column.DynamicContent': 'Dynamic content',
  'Grid.Column.Edit': 'Edit',
  'Grid.Column.Email': 'Email',
  'Grid.Column.Event': 'Event',
  'Grid.Column.Events': 'Events',
  'Grid.Column.FirstName': 'First Name',
  'Grid.Column.ISP': 'ISP',
  'Grid.Column.LastName': 'Last Name',
  'Grid.Column.LastVisitedAt': 'Last Visited At',
  'Grid.Column.LastVisitedUrl': 'Last Visited URL',
  'Grid.Column.LeadLabel': 'Lead Label',
  'Grid.Column.CustomerNumber': 'Customer Number',
  'Grid.Column.Modules': 'Modules',
  'Grid.Column.Name': 'Name',
  'Grid.Column.Number': 'Number',
  'Grid.Column.Pages': 'Pages',
  'Grid.Column.PageTitle': 'Page title',
  'Grid.Column.PageUrl': 'Page url',
  'Grid.Column.Role': 'Role',
  'Grid.Column.Score': 'Score',
  'Grid.Column.Status': 'Status',
  'Grid.Column.Status.Invalid': 'invalid',
  'Grid.Column.Status.Valid': 'valid',
  'Grid.Column.TargetGroup': 'Target Group',
  'Grid.Column.Url': 'Url',
  'Grid.Column.Users': 'Users',
  'Grid.Column.Value': 'Value',
  'Grid.Column.Label': 'Label',
  'Grid.Column.Key': 'Key',
  'Grid.Column.VisitStartTimestamp': 'Start Date',
  'Grid.Column.LastVisitSource': 'Source',
  'Grid.Column.Url.Labels': 'Url Labels',
  'Values.Leads.Type.QUALIFIED': 'Qualified',
  'Values.Leads.Type.UNQUALIFIED': 'Unqualified',
  'Visit.Source.ValueLabel.all': 'All',
  'Visit.Source.ValueLabel.campaign': 'Campaign',
  'Visit.Source.ValueLabel.direct': 'Direct',
  'Visit.Source.ValueLabel.search': 'Search',
  'Visit.Source.ValueLabel.social': 'Social',
  'Visit.Source.ValueLabel.website': 'Website',
  'Button.Hint.HideCompany': 'Hide Company',
  'Button.Hint.UnHideCompany': 'Unhide Company',
  'Button.Hint.MarkIsp': 'Mark Company as ISP',
  'Button.Hint.UnMarkIsp': 'Mark Company as not ISP',
  'Component.TwoColumnsSelect.AvailableLabel': 'Items',
  'Component.TwoColumnsSelect.SelectedLabel': 'Selected',
  'Component.TwoColumnsSelect.SearchPlaceholder': 'Search',
  'Component.TwoColumnsSelect.EmptySearchResult': 'No results',
  'Component.AccountSettings.New.HubspotSection.HubspotTitle': 'Hubspot',
  'Component.AccountSettings.New.HubspotSection.SelectUsersTitle': 'Hubspot Users',
  'Component.AccountSettings.New.HubspotSection.SelectUsersDescription': 'Please select the users you want to import from Hubspot.',
  'Component.AccountSettings.New.HubspotSection.ConfirmTokenUpdate': 'Do you want to update the token? If the new token belongs to other Hubspot Portal, it will remove any existing association between this Account and Hubspot Portal.',
  'Component.AccountSettings.New.HubspotSection.AccountIntegratedPlaceholder': 'Integrated with Hubspot Portal "{portalId}"',
  'Component.AccountSettings.New.HubspotSection.AccountNotIntegratedPlaceholder': 'Create Private App API token in Hubspot and add it here',
  'Component.SearchCreateCompanyModal.Title': 'Hubspot Company',
  'Component.SearchCreateCompanyModal.Description1': 'Please select an existing company in HubSpot or create a new one',
  'Component.SearchCreateCompanyModal.Description1PendingTask': 'Pending task. <br/> No equivalent Company found in HubSpot. <br/> Please select an existing company or create a new one. <br/> Task will be created automatically in a minute.',
  'Component.SearchCreateCompanyModal.Text.CompanyNameInLxp': 'Company name in LXP',
  'Component.SearchCreateCompanyModal.Text.CompanyNameFormLabel': 'Select company from Hubspot',
  'Component.SearchCreateCompanyModal.Info.PendingTaskCreatingInProgress': 'The pending tasks creation already in progress',
  'Component.SearchCreateCompanyModal.Text.NoCompaniesFound': 'No companies found',
  'Component.SearchCreateCompanyModal.Text.CompanyNamePlaceholder': 'Select item or start typing for a new search',
  'Component.SearchCreateCompanyModal.Button.UseExistingCompany': 'Use existing company',
  'Component.SearchCreateCompanyModal.Button.CreateNewCompany': 'Create new company',
  'Component.CreateHubspotTask.Form.AssigneeLabel': 'Assignee',
  'Component.CreateHubspotTask.Form.Pipeline': 'Pipeline',
  'Component.CreateHubspotTask.Form.DealStage': 'Deal Stage',
  'Component.CreateHubspotTask.Form.DealTopicCustomField': 'Topic',
  'Component.CreateHubspotTask.Form.DealClusterCustomField': 'Cluster',
  'Component.CreateHubspotTask.Form.DealTypeCustomField': 'Type',
  'Component.CreateHubspotTask.View.DealTopic': 'Topic',
  'Component.CreateHubspotTask.View.DealCluster': 'Cluster',
  'Component.CreateHubspotTask.View.DealType': 'Type',
  'Component.CreateHubspotTask.View.DealValueNone': 'None',
  'Component.CreateHubspotTask.Form.DueDateLabel': 'Due Date',
  'Component.CreateHubspotTask.Form.NotesLabel': 'Notes',
  'Component.CreateHubspotTask.Form.Priority': 'Priority',
  'Component.CreateHubspotTask.Form.PriorityLow': 'Low',
  'Component.CreateHubspotTask.Form.PriorityMedium': 'Medium',
  'Component.CreateHubspotTask.Form.PriorityHigh': 'High',
  'Component.CreateHubspotTask.Form.CreateTransferButton': 'Transfer to Hubspot',
  'Component.CreateHubspotTask.Form.Back': 'Back',
  'Component.CreateHubspotTask.Form.Close': 'Close',
  'Component.CreateHubspotTask.Form.Next': 'Next step',
  'Component.CreateHubspotTask.Form.Submit': 'Create all in CRM',
  'Component.CreateHubspotTask.Form.Header.1': 'Contact person search',
  'Component.CreateHubspotTask.Form.Header.2': 'Information for outreach',
  'Component.CreateHubspotTask.Form.Header.3': 'Additional information',
  'Component.CreateHubspotTask.Form.Header.4': 'CRM Responsible',
  'Component.CreateHubspotTask.Form.AgentLabel': 'AI Outreach Agent',
  'Component.CreateHubspotTask.Form.AISummary': 'AI Summary',
  'Component.CreateHubspotTask.Form.OutreachEmail': 'Outreach Email',
  'Component.CreateHubspotTask.Form.SelectPerson.Label': 'Please select persons from the list.',
  'Component.CreateHubspotTask.Form.Filter.Company': 'Filter by Company Name',
  'Component.CreateHubspotTask.Form.Filter.Domain': 'Filter by Domain',
  'Component.CreateHubspotTask.Form.Filter.Country': 'Filter by Country',
  'Component.CreateHubspotTask.Form.Filter.Title': 'Filter by Title',
  'Component.CreateHubspotTask.Form.Filter.Keyword': 'Filter by Keyword',
  'Component.CreateHubspotTask.Form.Filter.Seniority': 'Filter by Seniority',
  'Component.CreateHubspotTask.Form.Filter.ShowAll': 'Show all filters',
  'Component.CreateHubspotTask.Form.Filter.ShowLess': 'Show less',
  'Component.CreateHubspotTask.Form.Filter.NoCompaniesFound': 'No Companies Found Matching Criteria',
  'Component.CreateHubspotTask.Form.Filter.NoFilters': 'Please select Company or enter Domain',
  'Component.CreateHubspotTask.Form.Filter.ZeroCompany': '"{companyName}" not found. Please try to search manually',
  'Component.CreateHubspotTask.Form.Filter.MoreThanOneCompany': 'We found more than one "{companyName}", please select the concrete one.',
  'Component.CreateHubspotTask.Form.Validation.URL.Value': 'Must be valid url',
  'Component.CreateHubspotTask.View.AssignedTo': 'Assigned to',
  'Component.CreateHubspotTask.View.AssignedBy': 'From {fullname}',
  'Component.CreateHubspotTask.View.DueDate': 'Due Date',
  'Component.CreateHubspotTask.View.Notes': 'Notes',
  'Component.CreateHubspotTask.View.HubspotUrl': 'Hubspot Task URL',
  'Component.AccountSettings.New.HubspotSection.SelectLxpUsersTitle': 'User permissions',
  'Component.AccountSettings.New.HubspotSection.SelectLxpUsersDescription': 'Please select the users you want to give access to Hubspot features in LXP.',
  'Component.AccountSettings.New.HubspotSection.FeaturesLabel': 'Features',
  'Component.AccountSettings.New.HubspotSection.CreateTaskFeatureLabel': 'Create Tasks',
  'Component.AccountSettings.New.HubspotSection.CreateDealFeatureLabel': 'Create Deals',
  'Component.AccountSettings.New.HubspotSection.CreateCommentOnNewVisit': 'Update HS on new visit',
  'Component.AccountSettings.New.HubspotSection.DefaultPipelineLabel': 'Default Deal Pipeline',
  'Component.AccountSettings.New.HubspotSection.DefaultPipelinePlaceholder': 'Select a Pipeline',
  'Component.AccountSettings.New.HubspotSection.DefaultDealStagePlaceholder': 'Select a Deal Stage',
  'Component.CreateHubspotTask.View.DealPipeline': 'Pipeline',
  'Component.CreateHubspotTask.View.DealStage': 'Deal Stage',
  'Component.CreateHubspotTask.View.Priority': 'Priority',
  'Component.CreateHubspotTask.View.PriorityValueNone': 'None',
  'Component.AccountSettings.Edit.LanguageModelSection.LLMPromptTitle': 'AI Sales Assistant',
  'Component.AccountSettings.Edit.LanguageModelSection.LLMPromptDescription1': 'Below, you can provide additional instructions for the AI assistant, including details about your company, products, emphasis areas, and language preferences.',
  'Component.AccountSettings.Edit.LanguageModelSection.LLMPromptDescription2': 'The AI assistant has access to the company description, visit details, and technologies used.',
  'Component.AccountSettings.Edit.LanguageModelSection.LLMPromptDescription3': 'Simply select a company below to see the AI Assistant in action, utilizing the most recent visit for the test action.',
  'Component.AccountSettings.Edit.LanguageModelSection.CompanyLabel': 'Select a Company for a test',
  'Component.AccountSettings.Edit.LanguageModelSection.TestCompanyNoCompaniesFound': 'No Companies Found Matching Criteria',
  'Common.RemoteSelect.Placeholder': 'Please Start Typing to Select...',
  'Common.Test': 'Test',
  'Component.AIOutreachAgents.List.Title': 'AI Outreach Agent',
  'Component.AIOutreachAgents.List.Description': 'Here you will find all AI Outreach Agents.',
  'Component.AIOutreachAgents.List.SearchByNamePlaceholder': 'Type a name to search for a AI Outreach Agent',
  'Component.AIOutreachAgents.List.Create': 'New AI Outreach Agent',
  'Component.AIOutreachAgents.List.ViewBudget': 'View Budget',
  'Component.AIOutreachAgents.List.Budget': 'Budget',
  'Component.AIOutreachAgents.List.BudgetLeft': 'Left',
  'Component.AIOutreachAgents.Budget.CurrentMonthBudget': 'Current month budget',
  'Component.AIOutreachAgents.Budget.Type': 'Type',
  'Component.AIOutreachAgents.Budget.Usage': 'Budget Usage',
  'Component.AIOutreachAgents.Budget.Date': 'Date',
  'Component.AIOutreachAgents.Budget.Search': 'Search',
  'Component.AIOutreachAgents.Budget.Enrichment': 'Enrichment',
  'Component.AIOutreachAgents.New.Success.Text': 'New AI Outreach Agent was successfully created',
  'Component.AIOutreachAgents.New.Form.Title': 'New AI Outreach Agent',
  'Component.AIOutreachAgents.Edit.Success.Text': 'The AI Outreach Agent was successfully changed',
  'Component.AIOutreachAgents.Edit.Form.Title': 'Edit AI Outreach Agent',
  'Component.AIOutreachAgents.Remove.Success.Text': 'The AI Outreach Agent was successfully removed',
  'Component.AIOutreachAgents.Modal.Description': 'Do you really want to remove AI Outreach Agent "{aiOutreachAgentName}"?',
  'Component.AIOutreachAgents.Form.Name': 'AI Outreach Agent name',
  'Component.AIOutreachAgents.Form.EmailOrLinkedIn': 'Email/LinkedIn',
  'Component.AIOutreachAgents.Form.URLLabel.Title': 'Information for outreach',
  'Component.AIOutreachAgents.Form.URLLabel.Value': 'Webpage label',
  'Component.AIOutreachAgents.Form.URLLabel.Add': 'Add webpage label',
  'Component.AIOutreachAgents.Form.Prompt.CardTitle': 'Define your Agent',
  'Component.AIOutreachAgents.Form.Prompt.PromptDescription1': 'Please provide information about your company, your products and your target groups here. Try to describe in as much detail as possible, but as briefly as necessary, which products and services you sell/provide to which target groups.',
  'Component.AIOutreachAgents.Form.Prompt.PromptDescription2': 'This information will later be used by our system as a basis for creating individual outreach emails.',
  'Component.AIOutreachAgents.Form.Prompt.PromptDescription3': 'Therefore, all relevant products, a brief description of the company and details of the target groups should be provided here.',
  'Component.AIOutreachAgents.Form.Prompt.Company.Label': 'Select a Company for a Test',
  'Component.AIOutreachAgents.Form.Prompt.Company.NotFound': 'No Companies Found Matching Criteria',
  'Component.AIOutreachAgents.Validation.Name': 'Please input AI Outreach Agent name',
  'Component.AIOutreachAgents.Validation.URLLabel.Value': 'Please input webpage label',
  'Component.AIOutreachAgents.Validation.EmailOrLinkedIn': 'Must be valid email or linkedin url',
  'Component.AIOutreachAgents.Validation.URL.Value': 'Must be valid url',
  'Component.CurrentPasswordModal.Title': 'Password confirmation',
  'Component.CurrentPasswordModal.FieldLabel': 'Enter your current password',
  'Component.2FA.Title': 'Two Factor Authentication',
  'Component.2FA.Description': 'Add additional security to your account using two factor authentication.',
  'Component.2FA.EnabledText': 'You have enabled two factor authentication.',
  'Component.2FA.NotEnabledText': 'You have not enabled two factor authentication.',
  'Component.2FA.GoalDescription': 'When two factor authentication is enabled, you will be prompted for a secure, random token during authentication. You may retrieve this token from any TOTP app (e.g., Google Authenticator, Auth, and others) on your phone.',
  'Component.2FA.UserEnabledText': '{userName} has enabled two factor authentication.',
  'Component.2FA.UserNotEnabledText': '{userName} has not enabled two factor authentication.',
  'Component.2FA.UserGoalDescription': 'When two factor authentication is enabled, {userName} will be prompted for a secure, random token during authentication. {userName} may retrieve this token from any TOTP app (e.g., Google Authenticator, Auth, and others) on their phone.',
  'Component.2FA.Enable': 'Enable',
  'Component.2FA.FinishEnablingText': 'To finish enabling two factor authentication, scan the following QR code using your phone\'s authenticator application or enter the setup key and provide the generated OTP code.',
  'Component.2FA.SetupKey': 'Setup Key: {key}',
  'Component.2FA.CodeLabel': 'Code',
  'Component.2FA.Disable': 'Disable',
  'Component.2FA.RegenerateRecoveryCodes': 'Regenerate recovery codes',
  'Component.2FA.RecoveryCodesDescription': 'Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two factor authentication device is lost.',
  'Component.Administration.Clients.Label': 'Clients',
  'Component.Administration.Clients.List.Title': 'Clients',
  'Component.Administration.Clients.List.Description': 'Here you will find all clients and have possibility to move between them.',
  'Component.Administration.Clients.List.SearchByNamePlaceholder': 'Search by name',
  'Component.Administration.Clients.List.Create': 'New Client',
  'Component.Administration.Clients.List.Action.Select': 'Select Client',
  'Component.Administration.Clients.Status': 'Status',
  'Component.Administration.Clients.FilterByStatus': 'Filter By Status',
  'Component.Administration.Clients.Status.Signed': 'Signed',
  'Component.Administration.Clients.Status.HotLead': 'Hot Lead',
  'Component.Administration.Clients.Status.ColdLead': 'Cold Lead',
  'Component.Administration.Clients.Status.Lost': 'Lost',
  'Component.Administration.Clients.SignedTill': 'Signed Till',
  'Component.Administration.Clients.New.Success.Text': 'New Client was successfully created',
  'Component.Administration.Clients.New.Form.Title': 'New Client',
  'Component.Administration.Clients.Edit.Success.Text': 'The Client was successfully changed',
  'Component.Administration.Clients.Edit.Form.Title': 'Edit Client',
  'Component.Administration.Clients.Remove.Modal.Description': 'Do you really want to delete Client "{client}"? This action cannot be undone.',
  'Component.Administration.Clients.Remove.Success.Text': 'The Client was successfully deleted',
  'Component.Administration.Clients.Form.Name': 'Name',
  'Component.Administration.Clients.Form.Email': 'E-Mail',
  'Component.Administration.Clients.Form.IsActive': 'Is Active',
  'Component.Administration.Clients.Form.ActiveTill': 'Active till',
  'Component.Administration.Clients.Validation.Name': 'Please input Client name',
  'Component.Administration.Clients.Validation.Email': 'Please input valid E-Mail',
  'Component.Administration.Clients.Settings': 'Client Settings',
  'Component.Administration.Clients.Features': 'Features',
  'Component.Administration.Clients.Tokens': 'Tokens',
  'Component.Administration.Clients.Analytics': 'Analytics',
  'Component.Administration.Clients.Analytics.Type': 'Analytic Type',
  'Component.Administration.Clients.Analytics.BaseUri': 'Base URI',
  'Component.Administration.Clients.Analytics.ApiKey': 'API Key',
  'Component.Administration.Clients.Features.AiOutreachAgent': 'AI Outreach Agent',
  'Component.Administration.Clients.Features.IncomingRequestExtra': 'Incoming Request Extra',
  'Component.Administration.Clients.Features.LxpSessionRecording': 'LXP Session Recording',
  'Component.Administration.Clients.Features.ContactSearchesCallsBudget': 'Contact Searches Calls Budget',
  'Component.Administration.Clients.Features.ContactEnrichmentCallsBudget': 'Contact Enrichment Calls Budget',
  'Component.Administration.Clients.Features.MarkAsIsp': 'Mark as ISP',
  'Component.Administration.Clients.Features.MarkAsIsp.Emails': 'Emails',
  'Component.Administration.Clients.Features.MarkAsIsp.Validation.Emails': '{data} is not valid',
  'Component.Administration.Clients.Tokens.OpenAiApiToken': 'Open AI Api Token',
  'Component.Administration.Clients.Package': 'Package',
  'Component.Administration.Clients.Package.Placeholder': 'No package',
  'Component.Administration.Clients.FilterByPackage': 'Filter By Package',
  'Component.Administration.Clients.RecognitionUsages': 'Recognition Usage History',
  'Component.Administration.Clients.RecognitionUsages.Empty': 'This client has no recognition usage yet',
  'Component.Administration.Clients.RecognitionUsages.Period': 'Billing Period',
  'Component.Administration.Clients.RecognitionUsages.RecognitionsCount': 'Recognitions',
  'Component.Administration.Clients.RecognitionUsages.Remaining': 'Remaining',
  'Component.Administration.Clients.RecognitionUsages.IsLimitReached': 'Limit Reached',
  'Component.Administration.ClientPackages.Label': 'Client Packages',
  'Component.Administration.ClientPackages.List.Title': 'Client Packages',
  'Component.Administration.ClientPackages.List.Description': 'Here you will find all packages a client can be subscribed to.',
  'Component.Administration.ClientPackages.List.SearchByTitlePlaceholder': 'Search by title',
  'Component.Administration.ClientPackages.List.Create': 'New Package',
  'Component.Administration.ClientPackages.Form.Title': 'Title',
  'Component.Administration.ClientPackages.Form.MonthlyLimit': 'Monthly Limit',
  'Component.Administration.ClientPackages.Validation.Title': 'Please input a title between 3 and 255 characters',
  'Component.Administration.ClientPackages.Validation.MonthlyLimit': 'Please input a monthly limit greater than 0',
  'Component.Administration.ClientPackages.New.Form.Title': 'New Package',
  'Component.Administration.ClientPackages.New.Success.Text': 'New Package was successfully created',
  'Component.Administration.ClientPackages.Edit.Form.Title': 'Edit Package',
  'Component.Administration.ClientPackages.Edit.Success.Text': 'The Package was successfully changed',
  'Component.Administration.ClientPackages.Remove.Modal.Description': 'Do you really want to delete Package "{clientPackage}"? This action cannot be undone.',
  'Component.Administration.ClientPackages.Remove.Success.Text': 'The Package was successfully deleted',
  'Component.Administration.Users.Label': 'Administration Users',
  'Component.Administration.User.Administration.Title': 'Administration Users',
  'Component.Administration.User.Administration.Description': 'You can manage users who are LXP admins and will have access to all clients',
  'Component.Administration.User.Administration.Modal.Description': 'Do you really want to remove user "{first_name} {last_name}"?',
  'Component.Administration.User.Administration.SearchByEmailPlaceholder': 'Type an email to search for a User',
  'Component.Administration.User.Administration.Create': 'New User',
  'Component.Administration.User.Administration.New.Form.Title': 'Add a New Administration User',
  'Component.Administration.User.Administration.Edit.Form.Title': 'Edit Administration User',
  'Component.Administration.User.Administration.Edit.Success.Text': 'The administration user details were successfully updated.',
  'Component.Administration.User.Administration.Users.Edit.Title.UserName': 'User name',
  'Component.Administration.User.Administration.Users.New.Description': 'Create a new Administration User.',
  'Component.Administration.User.Administration.Users.Edit.Description': 'You can change here Administration User data.',
};



// WEBPACK FOOTER //
// ./src/i18n/en.js